// React && Redux
import React from "react";
// import { withRouter } from 'react-router';

// Material
import { withStyles } from "@material-ui/core/styles";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";

// Internal
import Spacer from "../atoms/Spacer";

// Config
import { buildConfig } from "../../config/master";

// Images
import primaryLogo from "../../assets/images/mptc-logo.svg";
import secondaryLogo from "../../assets/images/mptc-student-logo.svg";

// class styling
const styles = (theme) => ({
  appBar: {
    backgroundColor: "#f0f0f0 !important",
    borderBottom: "3px solid #5bb84d",
  },
  primaryLogo: {
    ...theme.appLogo,
    marginRight: 24,
    minWidth: 100,
    maxWidth: 193,
    width: "100%",
  },
  pointer: theme.pointer,
  secondaryLogo: {
    ...theme.appLogo,
    marginLeft: 24,
    minWidth: 100,
    maxWidth: 193,
    width: "100%",
  },
  toolbarWrapper: {
    backgroundColor: "#f0f0f0",
    color: "#333333",
    display: "flex",
    margin: "0 auto",
    minWidth: 360,
    width: "100%",
  },
});

class Header extends React.Component {
  render() {
    const { classes } = this.props;

    return (
      <div className="header-wrapper">
        <AppBar position="static" color="default" className={classes.appBar}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              width: "100%",
              maxWidth: "100%",
              padding: "0 24px",
              boxSizing: "border-box",
            }}
          >
            {/* tslint:disable-next-line:max-line-length */}
            <a
              href="https://www.morainepark.edu"
              className={classes.primaryLogo}
            >
              <img
                src={`${buildConfig.subpath}${primaryLogo}`}
                className={classes.primaryLogo}
                width="193"
                height="auto"
                alt="MPTC logo and link"
              />
            </a>
            <Spacer />
            <Typography style={{ minWidth: 120 }} variant="h1" color="inherit">
              Lab Lookup
            </Typography>
            <Spacer />
            <a
              href="https://student.morainepark.edu"
              className={classes.primaryLogo}
            >
              <img
                src={`${buildConfig.subpath}${secondaryLogo}`}
                className={classes.secondaryLogo}
                width="193"
                height="auto"
                alt="myMPTC Student logo and link"
              />
            </a>
          </div>
        </AppBar>
      </div>
    );
  }
}

export default withStyles(styles)(Header);
